import ContractVersionChanges from './ContractVersionChanges';

export default ContractVersionChanges;
